import axios from "axios";
import { DefaultAPIInstance } from "@/api";
const tariffList = 'http://dev.ttc.kz/api/app/v1/home-service-tariff/by-service';

const change_tariff_url = 'users/'

export const TariffAPI = {
    getTariffList(service) {
        return axios.get(`${tariffList}/${service}`)
    },
    setTariff(userId, tariff) {
        return DefaultAPIInstance.post(`${change_tariff_url}${userId}/change-tariff/`, tariff)
    }
}
